import { render, staticRenderFns } from "./GroupMemberItem.vue?vue&type=template&id=c50a8ba2"
import script from "./GroupMemberItem.vue?vue&type=script&lang=js"
export * from "./GroupMemberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports